import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";
import "../components/style.scss";
import "../components/columns.scss";
import Helmet from "react-helmet";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import { FaWhatsapp } from "react-icons/fa";

export default () => {
  const data = useStaticQuery(graphql`
    query {
      imageOne: file(
        relativePath: { eq: "images/autohemoterapia_en_cdmx.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1200) {
            aspectRatio
            sizes
            base64
            src
            srcSet
          }
        }
      }
      imageTwo: file(relativePath: { eq: "images/autohemoterapia_cdmx.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1200) {
            aspectRatio
            sizes
            base64
            src
            srcSet
          }
        }
      }
      imageThree: file(relativePath: { eq: "images/cdmx_autohemoterapia.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1200) {
            aspectRatio
            sizes
            base64
            src
            srcSet
          }
        }
      }
    }
  `);
  return (
    <div>
      <Helmet>
        <title>Autohemoterapia en la Ciudad de México</title>
        <meta
          name="description"
          content="¿Buscas la vacuna de la autohemoterapia? Nosotros tenemos la experencia y calidad de este método 100% seguro para tu salud."
        ></meta>
        <meta name="robots" content="index,follow"></meta>
        <meta
          property="og:title"
          content="Autohemoterapia en la CDMX"
        />
        <meta
          property="og:description"
          content="¿Buscas la vacuna de la autohemoterapia en la CDMX? Nosotros tenemos la experencia y calidad de este método 100% seguro para tu salud."
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/dpzoehc6i/image/upload/v1582235228/photo_2020-02-20_15-45-58_wb5bdm.jpg"
        />
        <meta
          property="og:url"
          content="https://autohemoterapia.mx/ciudad-de-mexico"
        />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <a
        href="https://api.whatsapp.com/send?phone=5215539994763&text=Hola%21%20Quisiera%20m%C3%A1s%20informaci%C3%B3n%20sobre%20la%20vacuna%20de%20Autohemoterapia.%20"
        className="float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaWhatsapp size={45} className="my-float" />
      </a>
      <section className="hero is-fullheight atlas-1">
        <Navbar />
        <div className="hero-body">
          <div className="container">
            <div className="columns has-text-centered">
              <div className="column"></div>
              <div className="column is-6">
                <h1 className="subtitle is-2 is-size-5-mobile has-text-white has-text-weight-bold is-uppercase">
                  Autohemoterapia en la CDMX
                </h1>
                <p className="subtitle is-5 is-size-6-mobile has-text-white">
                  ¿Quieres activar tu{" "}
                  <span className="has-text-white has-text-weight-bold">
                    Sistema Inmunológico?
                  </span>{" "}
                  No esperes más y combate enfermedades como diabetes, alergias,
                  acné, asma, artritis y lupus, entre otros.
                </p>
              </div>

              <div className="column"></div>
            </div>
            <div className="columns has-text-centered  has-text-centered-mobile">
              <div className="column"></div>
              <div className="column">
                <a
                  href="https://autohemoterapia.mx/contacto"
                  className="button is-danger is-inverted is-outlined is-rounded"
                >
                  AGENDA UNA CITA
                </a>
              </div>
              <div className="column">
                <a
                  href="#informacion"
                  className="button is-danger is-inverted is-outlined is-rounded"
                >
                  LEER MÁS
                </a>
              </div>
              <div className="column"></div>
            </div>
            <div className="columns">
              <div className="column">
                <p></p>
              </div>
              <div className="column is-3">
                <Img
                  fluid={data.imageOne.childImageSharp.fluid}
                  alt="Autohemoterapia en la CDMX"
                />
              </div>
              <div className="column"></div>
            </div>
          </div>
        </div>
        <div className="hero-foot"></div>
      </section>
      <section className="container" id="informacion">
        <div className="columns has-text-centered">
          <div className="column">
            <h2 className="subtitle is-2 is-size-5-mobile has-text-weight-bold is-uppercase">
              Siente los beneficios de la autohemoterapia
            </h2>
            <p className="subtitle is-5 is-size-6-mobile">
              ¿Sabías que la autohemoterapia es un mecanismo 100% natural que
              activa tus defensas?
            </p>
            <p className="subtitle is-5 is-size-6-mobile">
              De esta manera, tu cuerpo no solo combatirá las enfermedades que
              desafortunadamente padeces, sino que también te va a ayudar a
              prevenir otras enfermedades que te podrían dar.
            </p>
            <p className="subtitle is-5 is-size-6-mobile">
              Por si fuera poco, al ser completamente natural y estar basado en
              tu propio cuerpo, no te expones a los efectos secundarios de las
              medicinas.
            </p>
            <Img
              fluid={data.imageTwo.childImageSharp.fluid}
              alt="Autohemoterapia en la CDMX"
            />
            <h2 className="subtitle is-2 is-size-5-mobile has-text-weight-bold is-uppercase">
              Consultas en la CDMX
            </h2>
            <p className="subtitle is-5 is-size-6-mobile">
              Si vives en la Ciudad de México y estás buscando un tratamiento de
              autohemoterapia, has dado con el lugar indicado.
            </p>
            <p className="subtitle is-5 is-size-6-mobile">
              Nosotros te ofrecemos valoración gratuita de tu situación y
              encontraremos juntos un camino a seguir para que veas mejoría en
              tu salud.
            </p>
            <p className="subtitle is-5 is-size-6-mobile">
              Mucha gente ha confiado en nosotros y pueden ser testigos de cómo
              tu cuerpo puede trabajar para mejorarse así de mismo.
            </p>
            <p className="subtitle is-5 is-size-6-mobile">
              Si llevas muchos años sufriendo con problemas crónicos de salud,
              la autohemoterapia puede ser tu puerta de salida.
            </p>
            <p className="subtitle is-5 is-size-6-mobile">
              No dudes en ponerte en{" "}
              <a href="https://autohemoterapia.mx/contacto">contacto</a> con
              nosotros, vía telefónica o mediante Whatsapp.
            </p>
            <p className="subtitle is-5 is-size-6-mobile">
              ¡Estaremos encantados de conocerte!
            </p>
            <Img
              fluid={data.imageThree.childImageSharp.fluid}
              alt="Citas autohemoterapia en la CDMX"
            />
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};
